// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { updateBulkEditState } from 'redux/modules/bulkEdit'

const togglePathsSitesHighlight = pathId => (dispatch, getState) => {
  const { bulkEdit } = getState()

  let highlightedSiteIds = bulkEdit.get('highlightedSiteIds')

  const path = bulkEdit.get('bulkEditPaths').find(d => d.get('pathId') === pathId)

  const site1Id = path.getIn(['site1', 'segmentEndId'])
  const site2Id = path.getIn(['site2', 'segmentEndId'])

  const site1Highlighted = highlightedSiteIds.includes(site1Id)
  const site2Highlighted = highlightedSiteIds.includes(site2Id)

  // if both of them are highlighted, then toggle both them off.
  if (site1Highlighted && site2Highlighted) {
    highlightedSiteIds = highlightedSiteIds.filter(d => d !== site1Id && d !== site2Id)
    return dispatch(updateBulkEditState({ highlightedSiteIds }))
  }

  // determine if either of the path's sites need to be highlighted.
  if (!site1Highlighted) {
    highlightedSiteIds = highlightedSiteIds.push(site1Id)
  }
  if (!site2Highlighted) {
    highlightedSiteIds = highlightedSiteIds.push(site2Id)
  }

  return dispatch(updateBulkEditState({ highlightedSiteIds }))
}

export default togglePathsSitesHighlight
